var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
export {
  commonjsGlobal as c
};
//# sourceMappingURL=__commonjsHelpers__-5e0a36df.mjs.map
